export const load = () => ({
	title: 'What Is A Frame Step?',
	showTitle: true,
});
